import React from 'react'
import ReactMarkdown from 'react-markdown'
import type { Components } from 'react-markdown'
import { Link } from 'react-router-dom'
import type { BaseModalProps } from '../Modal/BaseModal.js'
import { BaseModal } from '../Modal/BaseModal.js'
import { useGetSystemMessages } from '../../Flux/Selector/index.ts'
import { DateWidget } from './DateWidget.js'

export const SystemNotificationsWidget = (props: BaseModalProps) => {
  const messages = useGetSystemMessages()

  const components: Components = {
    a: ({ href, children }) =>
      href?.startsWith('/') && !href.startsWith('//') ? (
        <Link to={href} onClick={() => props.onClose()}>
          {children}
        </Link>
      ) : (
        <a href={href}>{children}</a>
      )
  }

  const sorted = messages?.slice().sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()) ?? []

  return (
    <BaseModal isOpen={props.isOpen} onClose={props.onClose}>
      <div className="modal-box w-full max-w-3xl max-h-[90vh] flex flex-col p-0">
        <div className="px-6 pt-6 pb-2 border-b">
          <h3 className="text-lg text-center font-bold">System notification</h3>
        </div>

        <div className="overflow-y-auto px-6 py-4 grow prose max-w-none">
          {sorted.length > 0 ? (
            <div className="flex flex-col gap-6">
              {sorted.map((m, idx) => (
                <div key={m.id ?? idx} className="pb-4 border-b last:border-b-0">
                  <div className="text-sm text-gray-500 mb-2"><DateWidget date={m.createdAt} /></div>
                  <ReactMarkdown components={components}>{m.messageMd}</ReactMarkdown>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">No system notifications.</p>
          )}
        </div>

        <div className="modal-action border-t px-6 py-4">
          <button className="btn btn-primary" onClick={() => props.onClose()}>
            Close
          </button>
        </div>
      </div>
    </BaseModal>
  )
}
